export function scMdFunc(funcName,json){
   
    if(!(typeof sensors === 'undefined')){
        sensors.track(funcName,json);

    }
    
}
export function gotoLogin(){
    let isTuluApp = (/(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g).test(window.navigator.userAgent)
    let isToutiaoApp = (/(SwiftToutiao|ArtronToutiao|ArtExpress)/g).test(window.navigator.userAgent)
    let bridge = window.WebViewJavascriptBridge
    if(isToutiaoApp && bridge || isTuluApp && bridge){
        bridge.callHandler('appOpenLogin',{url:window.location.href}, function (response) { });
    }else{
        window.location.href = '//passport.artron.net/login?appId=1&redirect='+encodeURIComponent(window.location.href)
    }
}